import type {
    RateSnapshotListItem,
    RateSnapshotData,
    ClusterDaySelection,
} from './types';

const JSON_HEADERS = { 'Content-Type': 'application/json; charset=utf-8' };

export async function fetchSnapshots(includeArchived: boolean): Promise<RateSnapshotListItem[]> {
    const response = await fetch(`/api/rate-snapshots?includeArchived=${includeArchived}`);
    if (!response.ok) throw new Error('Failed to load snapshots');
    return await response.json();
}

export async function fetchSnapshot(id: string): Promise<RateSnapshotListItem> {
    const response = await fetch(`/api/rate-snapshots/${id}`);
    if (!response.ok) throw new Error('Failed to load snapshot');
    return await response.json();
}

export async function createSnapshot(request: {
    reservationId: string;
    name: string;
    description?: string;
    clusters: ClusterDaySelection[];
    roomTypeNames?: Record<string, string>;
    programTypeNames?: Record<string, string>;
}): Promise<{ rateSnapshotId: string }> {
    const response = await fetch('/api/rate-snapshots', {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify(request),
    });
    if (!response.ok) throw new Error('Failed to create snapshot');
    return await response.json();
}

export async function updateSnapshot(id: string, name: string, description: string | null): Promise<void> {
    const response = await fetch(`/api/rate-snapshots/${id}`, {
        method: 'PUT',
        headers: JSON_HEADERS,
        body: JSON.stringify({ name, description }),
    });
    if (!response.ok) throw new Error('Failed to update snapshot');
}

export async function archiveSnapshot(id: string): Promise<void> {
    const response = await fetch(`/api/rate-snapshots/${id}`, { method: 'DELETE' });
    if (!response.ok) throw new Error('Failed to archive snapshot');
}

export async function unarchiveSnapshot(id: string): Promise<void> {
    const response = await fetch(`/api/rate-snapshots/${id}/unarchive`, { method: 'POST' });
    if (!response.ok) throw new Error('Failed to unarchive snapshot');
}

export async function previewSnapshot(request: {
    reservationId: string;
    name: string;
    clusters: ClusterDaySelection[];
    roomTypeNames?: Record<string, string>;
    programTypeNames?: Record<string, string>;
}): Promise<RateSnapshotData> {
    const response = await fetch('/api/rate-snapshots/preview', {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify(request),
    });
    if (!response.ok) throw new Error('Failed to preview snapshot');
    return await response.json();
}

